import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import InputGroupWrapper from '../../InputGroupWrapper';
import messages from '../registrationMessages';
import FormGroupPart from './FormGroupPart';

import VatRateTypeSelector from '../../input/VatRateTypeSelector';
import DataCacheService from '@/shared/services/DataCacheService';

const UserFormGroup = ({ userId }) => (
  <div className="form-group">
    <FormGroupPart label={messages.User}>
      <p className="form-control-static">{DataCacheService.getUserName(userId)}</p>
    </FormGroupPart>
  </div>
);
UserFormGroup.propTypes = {
  userId: PropTypes.string,
};
UserFormGroup.defaultProps = { userId: null };
export default React.memo(UserFormGroup);
